import { v4 as uuidv4 } from 'uuid';
import { assignPublisherColors } from '../../../../commons/utils/publisherColors';
import { normalizePublicPublishers } from './normalizePublicPublisher';
import { getNearMePublishersAPI } from './api';

async function getNearMePublishers() {
    this.observed.nearMePublishersLoading = true;
    try {
        const session = this.env.session;
        const traceId = this.env.traceId;
        const timezone = this.env.countryInfo?.timezone;

        const res = await getNearMePublishersAPI({ token: session?.token, traceId, timezone });
        const data = res?.data?.data || res?.data || null;
        const publishers = data?.publishers || [];

        const colored = assignPublisherColors(normalizePublicPublishers(publishers));
        this.originNearMePublishers = colored;
        this.nearMePublishers = colored;
        this.observed.nearMePublishers = uuidv4();
    } finally {
        this.observed.nearMePublishersLoading = false;
    }
}

export default getNearMePublishers;
